<template>
  <div v-if="visible" class="schemaBasicForm">
    <schema-form-common
      ref="schemaForm"
      :schemaData="schemaData"
      :schemaConfig="schemaConfig"
      :schemaRules="schemaRules"
      :schemaBasicInfo="schemaBasicInfo"
    />
  </div>
</template>

<script>
import schemaFormCommon from '../../../../../components/schemaForm.vue'
import basicFormMixin from './basicFormMixin'

const COUPON_SCHEMA_DATA = { brand: '', code: '', link: '' }
const COUPON_SCHEMA_CONFIG = [
  [{ type: 'input', prop: 'brand', formItem: { label: 'brand' }, attrs: { placeholder: '请输入品牌' }, formItemProps: { trigger: 'blur' } }],
  [{ type: 'input', prop: 'code', formItem: { label: 'code' }, attrs: { placeholder: '请输入code' }, formItemProps: { trigger: 'blur' } }],
  [{ type: 'input', prop: 'link', formItem: { label: 'link' }, attrs: { placeholder: '请输入link' }, formItemProps: { trigger: 'blur' } }],
]
const WEB_SCHEMA_CONFIG = COUPON_SCHEMA_CONFIG.filter((row) => {
  const prop = row[0].prop
  return prop !== 'brand' && prop !== 'code'
})

export default {
  name: 'SchemaBasicForm',
  components: { schemaFormCommon },
  mixins: [basicFormMixin],
  props: {
    assetType: { type: String, default: '' },
    mode: { type: String, default: 'create' },
  },
  data() {
    return {
      schemaData: { ...COUPON_SCHEMA_DATA },
      schemaRules: {
        brand: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        code: [{ required: false, message: '请输入code码', trigger: 'blur' }],
        link: [
          { required: true, message: '请输入链接', trigger: 'blur' },
          {
            pattern: /^https?:\/\/.+/,
            message: '请输入有效的网址链接',
            trigger: 'blur',
          },
        ],
      },
      schemaBasicInfo: { label: '品牌基本信息' },
    }
  },
  computed: {
    visible() {
      return this.assetType === 'coupon(优惠券)' || this.assetType === 'web(网页)'
    },
    schemaConfig() {
      if (this.assetType === 'web(网页)') {
        return WEB_SCHEMA_CONFIG
      }
      return COUPON_SCHEMA_CONFIG
    },
  },
  watch: {
    assetType: {
      immediate: true,
      handler(val) {
        this.applySchemaVariant(val)
      },
    },
    schemaData: {
      deep: true,
      handler() {
        this.scheduleCompletionEmit()
      },
    },
  },
  methods: {
    applySchemaVariant(val) {
      if (val === 'web(网页)') {
        this.schemaData = { link: '' }
      } else if (val === 'coupon(优惠券)') {
        this.schemaData = { ...COUPON_SCHEMA_DATA }
      }
    },
    buildExtaPayload() {
      return { ...this.schemaData }
    },
    loadFromExta(exta) {
      const base =
        this.assetType === 'web(网页)'
          ? { link: '' }
          : { ...COUPON_SCHEMA_DATA }
      this.schemaData = { ...base, ...(exta || {}) }
    },
    reset() {
      this.applySchemaVariant(this.assetType)
    },
    validate() {
      if (!this.$refs.schemaForm) {
        return Promise.resolve()
      }
      return new Promise((resolve, reject) => {
        this.$refs.schemaForm.validate((valid, errorMsg) => {
          if (valid) {
            resolve()
          } else {
            reject(errorMsg)
          }
        })
      })
    },
    captureSnapshot() {
      return { ...this.schemaData }
    },
  },
}
</script>
